export type WorkEnvironment = 'team' | 'broker';

const STORAGE_KEY = 'autofluxo-work-environment';
let currentChoice: { userId: string; environment: WorkEnvironment } | null = null;

export function getEnvironmentChoice(userId: string): WorkEnvironment | null {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    currentChoice = stored ? JSON.parse(stored) : currentChoice;
  } catch {
    // Keep the current-tab choice in memory when storage is unavailable.
  }
  return currentChoice?.userId === userId &&
    (currentChoice.environment === 'team' || currentChoice.environment === 'broker')
    ? currentChoice.environment : null;
}

export function setEnvironmentChoice(userId: string, environment: WorkEnvironment) {
  currentChoice = { userId, environment };
  try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(currentChoice)); } catch { /* Memory fallback. */ }
}

export function clearEnvironmentChoice() {
  currentChoice = null;
  try { sessionStorage.removeItem(STORAGE_KEY); } catch { /* Memory fallback. */ }
}